import React, { useEffect, useState } from 'react';
import { moodboardService } from '../lib/moodboardService';
import { RoomSize } from '../types/moodboard';

const RoomSizeManager: React.FC = () => {
  const [sizes, setSizes] = useState<RoomSize[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [newSizeName, setNewSizeName] = useState('');

  const fetchSizes = async () => {
    try {
      setLoading(true);
      const sizeList = await moodboardService.getRoomSizes();
      setSizes(sizeList);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSizes();
  }, []);

  const handleAddSize = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newSizeName.trim()) {
      return;
    }

    try {
      await moodboardService.addRoomSize(newSizeName);
      setNewSizeName('');
      fetchSizes(); // Refresh the list
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
    }
  };

  if (loading) return <p>Loading sizes...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="bg-white shadow rounded-lg p-4 mt-6">
      <h3 className="text-lg font-semibold mb-2">Room Sizes</h3>
      <form onSubmit={handleAddSize} className="flex items-center space-x-2 mb-4">
        <input
          type="text"
          value={newSizeName}
          onChange={(e) => setNewSizeName(e.target.value)}
          placeholder="New size name"
          className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
        />
        <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
          Add
        </button>
      </form>
      <ul className="divide-y divide-gray-200">
        {sizes.map((size) => (
          <li key={size.id} className="py-2">{size.name}</li>
        ))}
      </ul>
    </div>
  );
};

export default RoomSizeManager; 